export default function truncateText(text, limit) {
  if (text.length > limit) {
    for (let i = limit; i > 0; i -= 1) {
      if (text.charAt(i) === ' ' && (text.charAt(i - 1) !== ',' || text.charAt(i - 1) !== '.' || text.charAt(i - 1) !== ';')) {
        return `${text.substring(0, i)}...`;
      }
    }
    return `${text.substring(0, limit)}...`;
  }
  return text;
}

export function toPercent(decimal, fixed = 0) {
  return `${(decimal * 100).toFixed(fixed)}%`;
}

export function toCurrency(value, maximumFractionDigits = 0) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits,
  });

  return formatter.format(value);
}

export function toFormattedNumber(decimal, fixed = 0) {
  if (!decimal && decimal !== 0) return null;
  const formatter = new Intl.NumberFormat('en-US');
  return formatter.format((decimal).toFixed(fixed));
}

// wrap text function adopted from https://bl.ocks.org/mbostock/7555321
export function wrap(text, width) {
  const words = text.text().split(/\s+/).reverse();
  let word;
  let line = [];
  let lineNumber = 0;
  const lineHeight = 1.1; // ems
  const y = text.attr('y');
  const dy = parseFloat(text.attr('dy'));
  let tspan = text.text(null).append('tspan').attr('x', 0).attr('y', y)
    .attr('dy', `${dy}em`);
  // eslint-disable-next-line no-cond-assign
  while (word = words.pop()) {
    line.push(word);
    tspan.text(line.join(' '));
    if (tspan.node().getComputedTextLength() > width) {
      line.pop();
      tspan.text(line.join(' '));
      line = [word];
      // eslint-disable-next-line no-plusplus
      tspan = text.append('tspan').attr('x', 0).attr('y', y).attr('dy', `${++lineNumber * lineHeight + dy}em`)
        .text(word);
    }
  }
}
